import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  BackendService,
  FileService,
  HttpOptions,
  PaginatedResponseModel,
} from '@ipg/ngx-frontend-toolset';

export interface AnnouncementSound {
  _id: string;
  label: string;
  fileId: string;
  isDefault: boolean;
  createdAt: string;
  updatedAt: string;
}

@Injectable({
  providedIn: 'root',
})
export class AnnouncementSoundsService {
  private readonly _backend = inject(BackendService);
  private readonly _file = inject(FileService);

  getAll(
    options?: HttpOptions
  ): Observable<PaginatedResponseModel<AnnouncementSound[]>> {
    return this._backend.get('/announcement-sounds', options);
  }

  getFileUrl(fileId: string): string {
    return this._file.get(fileId, true).href;
  }
}
